import { AxiosResponse } from "axios";
import { makeAPIRequest } from "../hook/request";
import { API_ENDPOINT } from "../utils/constants";

class DiseaseAPI {
  async getAllDisease(userId: string): Promise<any> {
    const res: AxiosResponse = await makeAPIRequest({
      method: "GET",
      url: `${API_ENDPOINT.GET_ALL_DISEASE_PREDICTIONS}?user_id=${userId}`,
    });
    return res.data;
  }

  async getAllScores(userId: string): Promise<any> {
    const res: AxiosResponse = await makeAPIRequest({
      method: "GET",
      url: `${API_ENDPOINT.GET_ALL_SCORES_PREDICTIONS}?user_id=${userId}`,
    });
    return res.data;
  }

  async saveScore(params: any): Promise<any> {
    const res: AxiosResponse = await makeAPIRequest({
      method: "POST",
      url: `${API_ENDPOINT.SAVE_SCORE}`,
      data: params,
    });
    return res.data;
  }

  async checkPercentageScore(userId: string): Promise<any> {
    const res: AxiosResponse = await makeAPIRequest({
      method: "GET",
      url: `${API_ENDPOINT.GET_ANSWER_COUNTS_PERCENTAGE}?user_id=${userId}`,
    });
    return res.data;
  }

  async getScoreLabels(userId: string, scoreName: any): Promise<any> {
    const res: AxiosResponse = await makeAPIRequest({
      method: "GET",
      url: `${API_ENDPOINT.GET_SCORE_LABELS}?user_id=${userId}&score_name=${scoreName}`,
    });
    return res.data;
  }

  async saveInitialPageUserDetails(params: any): Promise<any> {
    const res: AxiosResponse = await makeAPIRequest({
      method: "POST",
      url: `${API_ENDPOINT.GET_USER_DETAILS_STRAPI}`,
      data: JSON.stringify({ data: params }),
    });
    return res.data;
  }

  async getUserDetails(
    userId: string,
    client: any,
    calledFrom?: string
  ): Promise<any> {
    // console.log("calledFrom: ", calledFrom);

    const res: AxiosResponse = await makeAPIRequest({
      method: "GET",
      url: `${API_ENDPOINT.GET_USER_DETAILS_STRAPI}?populate[0]=user&filters[client][$eq]=${client}&filters[user_id][$eq]=${userId}&sort=createdAt:desc&pagination[page]=1&pagination[pageSize]=1`,
    });

    return res.data?.data?.[0] ?? null;
  }

  async getUserDetailsforDashboard(userId: string, client: any): Promise<any> {
    const res: AxiosResponse = await makeAPIRequest({
      method: "GET",
      url: `${API_ENDPOINT.GET_USER_DETAILS_STRAPI}?populate[0]=user&filters[client][$eq]=${client}&filters[user_id][$eq]=${userId}&sort=createdAt:desc&pagination[page]=1&pagination[pageSize]=1`,
    });

    return res?.data?.data[0] || null;
  }

  async savePdf(params: any): Promise<any> {
    const res: AxiosResponse = await makeAPIRequest({
      method: "POST",
      url: `${API_ENDPOINT.SAVE_REPORTS}`,
      data: params,
    });
    return res.data;
  }

  async getScoreQuestions(userId: string, scoreType: string): Promise<any> {
    const res: AxiosResponse = await makeAPIRequest({
      method: "GET",
      url: `${API_ENDPOINT.GET_SCORE_QUESTIONS}?user_id=${userId}&score_type=${scoreType}`,
    });
    return res.data;
  }

  async createUser(params: any): Promise<any> {
    const res: AxiosResponse = await makeAPIRequest({
      method: "POST",
      url: `${API_ENDPOINT.CREATE_CLINIC_USER}`,
      data: params,
    });
    return res.data;
  }

  async uploadDocuments(params: any): Promise<any> {
    const res: AxiosResponse = await makeAPIRequest({
      method: "POST",
      url: `${API_ENDPOINT.UPLOAD_DOCUMENTS}`,
      data: params,
    });
    return res.data;
  }

  async getVikritiRecommendation(userId: string): Promise<any> {
    const res: AxiosResponse = await makeAPIRequest({
      method: "GET",
      url: `${API_ENDPOINT.GET_VIKRITI_RECOMMENDATIONS}?user_id=${userId}`,
    });
    return res.data;
  }

  async getVikritiAnalysis(userId: string): Promise<any> {
    const res: AxiosResponse = await makeAPIRequest({
      method: "GET",
      url: `${API_ENDPOINT.GET_VIKRITI_ANALYSIS}?user_id=${userId}`,
    });
    return res.data;
  }

  async uploadDocumentsForAnalysis(params: any): Promise<any> {
    const res: AxiosResponse = await makeAPIRequest({
      method: "POST",
      url: `${API_ENDPOINT.SAVE_MEDIA_FOR_ANALYSIS}`,
      data: params,
    });
    return res.data;
  }

  async triggerAnalysis(params: any): Promise<any> {
    const res: AxiosResponse = await makeAPIRequest({
      method: "POST",
      url: `${API_ENDPOINT.TRIGGER_ANALYSIS}`,
      data: params,
    });
    return res.data;
  }

  async getSimilarShlokas(query: string): Promise<any> {
    const res: AxiosResponse = await makeAPIRequest({
      method: "GET",
      url: `${API_ENDPOINT.GET_AYURVEDA_CORRELATION}?user_query=${query}`,
    });
    return res.data;
  }

  async getIndividualScoreQuestionResponse(
    userId: string,
    scoreName: string,
    page: number,
    pageSize: number
  ): Promise<any> {
    const res: AxiosResponse = await makeAPIRequest({
      method: "GET",
      url: `${API_ENDPOINT.GET_INDIVIDUAL_SCORE_QUESTION_RESPONSE}?pagination[withCount]=true&pagination[page]=${page}&pagination[pageSize]=${pageSize}&populate=scores_questionnaire&filters[user_id]=${userId}&filters[scores_questionnaire][score_name]=${scoreName}&sort=createdAt:desc`,
    });
    return res.data;
  }

  async getIndividualQuestionResponse(
    userId: string,
    scoreName: string,
    page: number,
    pageSize: number,
    questionId: string
  ): Promise<any> {
    const res: AxiosResponse = await makeAPIRequest({
      method: "GET",
      url: `${API_ENDPOINT.GET_INDIVIDUAL_SCORE_QUESTION_RESPONSE}?pagination[withCount]=true&pagination[page]=${page}&pagination[pageSize]=${pageSize}&populate=scores_questionnaire&filters[user_id]=${userId}&filters[scores_questionnaire][score_name]=${scoreName}&filters[scores_questionnaire][question_id]=${questionId}&sort=createdAt:desc`,
    });
    return res.data;
  }

  async getSymptomSuggestion(keyword: string): Promise<any> {
    const res: AxiosResponse = await makeAPIRequest({
      method: "GET",
      url: `${API_ENDPOINT.GET_SYMTOM_SUGGESTIONS}?filters[name][$containsi]=${keyword}&pagination[pageSize]=100`,
    });
    return res.data;
  }

  async saveUserSymptoms(params: any): Promise<any> {
    const res: AxiosResponse = await makeAPIRequest({
      method: "POST",
      url: `${API_ENDPOINT.SAVE_SYMPTOM_SUGGESTIONS}`,
      data: params,
    });
    return res.data;
  }

  async getUseReportUploads(
    userId: string,
    clientName: string,
    analysis_type: string
  ): Promise<any> {
    const res: AxiosResponse = await makeAPIRequest({
      method: "GET",
      url: `${API_ENDPOINT.GET_USER_REPORT_UPLODS}?user_id=${userId}&client=${clientName}&analytics_type=${analysis_type}`,
    });
    return res.data;
  }

  async getAllDcotors(): Promise<any> {
    const res: AxiosResponse = await makeAPIRequest({
      method: "GET",
      url: `${API_ENDPOINT.GET_ALL_DOCTORS}`,
    });
    return res.data;
  }

  async bookAppointment(params: any): Promise<any> {
    const res: AxiosResponse = await makeAPIRequest({
      method: "POST",
      url: `${API_ENDPOINT.BOOK_APPOINTMENTS}`,
      data: params,
    });
    return res.data;
  }

  async getAllAppointmentsBookedForUser(userId: string): Promise<any> {
    const res: AxiosResponse = await makeAPIRequest({
      method: "GET",
      url: `${API_ENDPOINT.GET_ALL_APPOINTMENTS_FOR_USER}?mobile=${userId}`,
    });
    return res.data;
  }

  async getUserSymptoms(userId: string): Promise<any> {
    const res: AxiosResponse = await makeAPIRequest({
      method: "GET",
      url: `${API_ENDPOINT.GET_USER_SYMPTOMS}?mobile=${userId}`,
    });
    return res.data;
  }

  async getUserPrescription(userId: string): Promise<any> {
    const res: AxiosResponse = await makeAPIRequest({
      method: "GET",
      url: `${API_ENDPOINT.GET_USER_PRESCRIPTION}?patientId=${userId}`,
    });
    return res.data;
  }

  async getUserSymptomsforPDF(
    userId: string,
    pageNumber: number = 1,
    pageSize: number = 100
  ): Promise<any> {
    const res: AxiosResponse = await makeAPIRequest({
      method: "GET",
      url: `${API_ENDPOINT.GET_USER_SYMPTOMS}?filters[user_id][$eq]=${userId}&pagination[pageSize]=${pageSize}&pagination[page]=${pageNumber}&populate=symptoms&&sort=createdAt:desc`,
    });
    return res.data;
  }

  async getBloodReportValueV1(
    userId: string,
    pageNumber: number,
    pageSize: number
  ): Promise<any> {
    const res: AxiosResponse = await makeAPIRequest({
      method: "GET",
      url: `${API_ENDPOINT.GET_BLOOD_REPORT_VALUE}?filters[user_id][$in][1]=${userId}&pagination[page]=${pageNumber}&pagination[pageSize]=${pageSize}`,
    });
    return res.data;
  }

  async getBloodReportReadings(
    userId: string,
    client: string,
    startTime: string,
    endTime: string,
    pageNumber: number,
    pageSize: number
  ): Promise<any> {
    const res: AxiosResponse = await makeAPIRequest({
      method: "GET",
      url: `${API_ENDPOINT.GET_BLOOD_REPORT_VALUE}?pagination[page]=${pageNumber}&populate=ud&pagination[pageSize]=${pageSize}&filters[ud][user_id][$eq]=${userId}&filters[ud][client][$eq]=${client}&filters[createdAt][$gte]=${startTime}&filters[createdAt][$lte]=${endTime}&sort=createdAt:desc`,
    });
    return res.data;
  }

  async getPastUploadedDocumentation(
    userId: string,
    client: string,
    pageNumber: number,
    pageSize: number,
    analysisType: string
  ): Promise<any> {
    const res: AxiosResponse = await makeAPIRequest({
      method: "GET",
      url: `${API_ENDPOINT.IMAGE_ANALYSIS_STORE}?populate=user_report_individual_detail,media&filters[user_report_individual_detail][client]=${client}&filters[user_report_individual_detail][user_id]=${userId}&sort=updatedAt:desc&pagination[page]=${pageNumber}&pagination[pageSize]=${pageSize}&filters[analysis_type]=${analysisType}`,
    });
    return res.data;
  }

  async updateDocument(docId: string, isVisible: boolean): Promise<any> {
    const res: AxiosResponse = await makeAPIRequest({
      method: "PUT",
      url: `${API_ENDPOINT.UPDATE_IMAGE_ANALYSIS_STORE}${docId}`,
      headers: {
        "Content-Type": "application/json",
      },
      data: {
        data: {
          is_visible: isVisible,
        },
      },
    });
    return res.data;
  }

  async getDcotorAppointment(
    doctorId: string,
    epochTime: string
  ): Promise<any> {
    const res: AxiosResponse = await makeAPIRequest({
      method: "GET",
      url: `${API_ENDPOINT.GET_DOCTOR_SLOT}?userId=${doctorId}&date=${epochTime}`,
    });
    return res.data;
  }

  async getLastAppointmentwithGrace(
    userId: string,
    docId: string
  ): Promise<any> {
    const res: AxiosResponse = await makeAPIRequest({
      method: "GET",
      url: `${API_ENDPOINT.GET_LATEST_APPT}?PatientId=${userId}&UserId=${docId}`,
    });
    return res.data;
  }

  async deleteUserFromStrapi(userId: string): Promise<any> {
    const res: AxiosResponse = await makeAPIRequest({
      method: "DELETE",
      url: `${API_ENDPOINT.DELETE_USER_DETAILS_STRAPI}/${userId}`,
    });
    return res.data;
  }

  async deleteUserSymptomStrapi(userId: string): Promise<any> {
    const res: AxiosResponse = await makeAPIRequest({
      method: "DELETE",
      url: `${API_ENDPOINT.DELETE_USER_SYMPTOMS_STRAPI}/${userId}`,
    });
    return res.data;
  }

  async deleteScoreQuestionResponseStrapi(userId: string): Promise<any> {
    const res: AxiosResponse = await makeAPIRequest({
      method: "DELETE",
      url: `${API_ENDPOINT.DELETE_Score_QUESTION_RESPONSE_STRAPI}/${userId}`,
    });
    return res.data;
  }

  async deleteImageAnalysisStore(userId: string): Promise<any> {
    const res: AxiosResponse = await makeAPIRequest({
      method: "DELETE",
      url: `${API_ENDPOINT.DELETE_IMAGE_ANALYSIS_STORE}/${userId}`,
    });
    return res.data;
  }

  async deleteNandiBloodReportParamter(userId: string): Promise<any> {
    const res: AxiosResponse = await makeAPIRequest({
      method: "DELETE",
      url: `${API_ENDPOINT.DELETE_NANDI_BLOOD_PARAMETERS}/${userId}`,
    });
    return res.data;
  }

  async downloadReportPdf(client: string, user_id: string, reportType: string) {
    const res: AxiosResponse = await makeAPIRequest({
      method: "GET",
      url: `${API_ENDPOINT.DOWNLOAD_PDF_REPORT}?user_id=${user_id}&client=${client}&reportType=${reportType}`,
      responseType: "blob",
    });
    return res.data;
  }

  async updateUserDetails(params: any, entry_id: string) {
    const res: AxiosResponse = await makeAPIRequest({
      method: "PUT",
      url: `${API_ENDPOINT.GET_USER_DETAILS_STRAPI}/${entry_id}`,
      data: JSON.stringify({ data: params }),
    });
    return res.data;
  }

  async downlaodPrescription(
    client: string,
    user_id: string,
    prescriptionId: number
  ) {
    const res: AxiosResponse = await makeAPIRequest({
      method: "GET",
      url: `${API_ENDPOINT.DONWLOAD_PRESCRITPION_PDF}?user_id=${user_id}&client=${client}&prescriptionId=${prescriptionId}`,
      responseType: "blob",
    });
    return res.data;
  }
}

export default new DiseaseAPI();
